import styled, { keyframes, css } from "styled-components";

interface Props {
  size?: "small" | "medium" | "large";
  circleColor?: string;
  indicatorColor?: string;
}

const getSizeStyles = (size?: Props["size"]) => {
  switch (size) {
    case "small": {
      return css`
        width: 12px;
        height: 12px;
      `;
    }
    case "large": {
      return css`
        width: 48px;
        height: 48px;
      `;
    }
    default: {
      return css`
        width: 24px;
        height: 24px;
      `;
    }
  }
};

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
export const Spinner = styled.div<Props>`
  animation: ${rotate360} 1s linear infinite;
  transform: translateZ(0);

  border-top: 2px solid ${(props) => props.circleColor};
  border-right: 2px solid ${(props) => props.circleColor};
  border-bottom: 2px solid ${(props) => props.circleColor};
  border-left: 2px solid ${(props) => props.indicatorColor};
  background: transparent;
  border-radius: 50%;
  ${(props) => getSizeStyles(props.size)}
`;

Spinner.defaultProps = {
  size: "medium",
  circleColor: "grey",
  indicatorColor: "black",
};

export default Spinner;
